import { createApp } from 'vue';
import App from './App.vue';
import { elementPlusPlugin, vuetifyPlugin } from 'blackburn-components';

import auth0Client from '~/plugins/authClient';
import BlackburnComponents from '~/plugins/blackburn-components';
import notifcationService from './plugins/notification-service';
import i18n from '~/plugins/i18n';
import arcaneApiGatewayPlugin from '~/plugins/arcane-api-gateway';
import realtimePlugin from '~/plugins/realtime';
import filterFormPlugin from '~/plugins/filter-form';

import store from '~/store';
import router from '~/router';

import hasAccessDirective from '~/directives/hasAccessDirective';
import hasAccessByRole from '~/directives/hasAccessByRole';

import ArcaneApi from '~/services/arcane-api';

import '~/assets/styles/global.css';
import '~/assets/styles/quill.css';
import '~/assets/styles/main.css';
import 'blackburn-components/dist/style.css';

import { GlobalWorkerOptions } from 'vue-pdf-embed/dist/index.essential.mjs';

GlobalWorkerOptions.workerSrc = '/pdf.worker.min.mjs';

// add external stylesheet
const loadExternalCSS = (url) => {
  const link = document.createElement('link');
  link.href = url;
  link.rel = 'stylesheet';
  document.head.appendChild(link);
};

const init = () => {
  const app = createApp(App);

  loadExternalCSS(
    `https://d1azc1qln24ryf.cloudfront.net/214395/Blackburn/style.css?${process.env.BUILDKITE_BUILD_NUMBER}`,
  );
  app.use(vuetifyPlugin);
  app.use(elementPlusPlugin);
  app.use(BlackburnComponents);
  app.use(router);
  app.use(auth0Client);
  app.use(i18n);
  app.use(store);
  app.use(arcaneApiGatewayPlugin);
  app.use(notifcationService);
  app.use(realtimePlugin);
  app.use(filterFormPlugin);

  // TODO this will be deleted in the future as all the resources will be accessed within API Gateway
  const arcaneApi = ArcaneApi.getInstance(store);
  app.provide('arcaneApi', arcaneApi);

  // Register the directive globally
  app.directive('has-access', hasAccessDirective);
  app.directive('has-access-by-role', hasAccessByRole);

  app.mount('#app');
};

init();
